/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="79.64"
        height="95.58"
        viewBox="0 0 79.64 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="none"
          stroke="#fff"
          d="M39.82 94.29C4.94 81.76 1.25 55.02 1.25 30.95V15.78c15.6-.47 28.1-5.14 38.57-14.53 10.47 9.39 23 14.06 38.57 14.53v15.21c0 24.07-3.69 50.81-38.57 63.3Z"
          className="icon-stroke icon-base"
          strokeWidth="2.5"
          strokeLinejoin="round"
          strokeLinecap="round"/>
        <path
          fill="#ffb81c"
          d="M43.89 65.63V51.89h13.67v-8.2H43.89V29.95h-8.14v13.74H22.08v8.2h13.67v13.74Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M35.75 66.38a.74.74 0 0 1-.74-.64v-13.1H22.08a.74.74 0 0 1-.74-.65v-8.3a.75.75 0 0 1 .65-.74h13v-13a.75.75 0 0 1 .65-.74h8.24a.75.75 0 0 1 .74.65v13.08h12.94a.75.75 0 0 1 .74.65v8.3a.76.76 0 0 1-.65.75h-13v13a.76.76 0 0 1-.65.75h-8.25Zm7.39-35.68H36.5v13a.75.75 0 0 1-.65.74h-13v6.7h12.9a.75.75 0 0 1 .74.65v13.09h6.64v-13a.75.75 0 0 1 .65-.74h13v-6.7H43.89a.75.75 0 0 1-.74-.65V30.7Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'ShieldWithCrossIcon';

export default Icon;
